var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { t } from '@mp/locale';
import { StepContext } from "../../hooks/StepContext";
import "./StepProgress.scss";
export default function StepProgress() {
    var _a = useContext(StepContext), activeStep = _a.step, steps = _a.steps, canCheckout = _a.canCheckout;
    return (_jsx("ol", __assign({ className: "mp-step-progress" }, { children: steps.map(function (step, index) {
            var stepClasses = "";
            if (index === activeStep) {
                stepClasses = "is-active";
            }
            if (index > activeStep) {
                stepClasses = "is-disabled";
            }
            if ((canCheckout && step.name === "review") ||
                (!canCheckout && step.name === "checkout")) {
                return null;
            }
            return (_jsx("li", __assign({ id: "step-".concat(step.name), className: stepClasses }, { children: t("CAPTURE_SERVICES.ORDER.STEPS.".concat(step.name, ".label")) }), index));
        }) })));
}
